// extracted by css-extract-rspack-plugin
export default {"cls1":"AvatarCell-cls1_AXo","cls2":"AvatarCell-cls2_Stn AvatarCell-cls1_AXo"};